<template>
  <div class="accountInformation"></div>
</template>
<style scoped></style>
<script>
  export default {
    data() {
      return {

      }
    }
  }

</script>
